<template>
    <div class="content">
        <topWell />
        <div class="mainBox">
            <listNav :title="'投资项目'" :navData="classData" @checkPageInd="checkPageInd" />
            <div id="main" v-if="classType === '重点投向'" v-loading="!pageLoading">
                <div class="tagleft" style="width: 30%">
                    <img src="../../static/icon-tzfx.png" style="height: 80px;" />
                    <img src="../../static/line.png" class="icon-line" />
                    <div class="leftTitle">投资方向</div>
                </div>
                <div class="tagright" style="width: 70%">
                    <dataNone v-if="productList.length <= 0" style="margin: 0 auto;"></dataNone>
                    <div class="item" v-for="(v, i) of productList" :key="i" v-else>
                        <img :src="v.coverOssUrl">
                        <div class="title">{{ v.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="culture" v-if="classType === '重点投向'">
            <div class="box">
                <div class="tagleft" style="width: 20%">
                    <img src="../../static/icon-sdzl.png" style="height: 80px;" />
                    <img src="../../static/line.png" class="icon-line" />
                    <div class="leftTitle">构建三大战略性新兴产业集群</div>
                </div>
                <div class="info" style="width: 76%">
                    <div class="item" v-for="v of StrategyData" :key="v.id">
                        <img src="../../static/img-product.png" style="width: 100%;">
                        <div class="title">
                            {{ v.name }}
                        </div>
                        <div class="tit">
                            {{ v.sketch }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="bottom" v-if="classType === '重点投向'">
            <div class="tagleft" style="width: 30%">
                <img src="../../static/icon-ldzd.png" style="height: 80px;" />
                <img src="../../static/line.png" class="icon-line" />
                <div class="leftTitle">聚焦两大重点
                    投资领域
                </div>
            </div>
            <div class="tagright" style="width: 70%">
                <div class="item" v-for="v of InvestorData" :key="v.id">
                    <img src="../../static/project-img.png">
                    <div class="text">
                        <div class="title">{{ v.name }}</div>
                        <div class="tit">{{ v.sketch }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="productList" v-if="classType !== '重点投向'" v-loading="!pageLoading">
            <dataNone v-if="productList.length <= 0" style="margin: 0 auto;"></dataNone>
            <div class="item" v-for="(v, i) of productList" :key="i" v-else>
                <img :src="v.coverOssUrl">
                <div class="title">{{ v.name }}</div>
                <div class="tit">{{ v.sketch }}</div>
            </div>
        </div>
        <div v-if="classType !== '重点投向'" class="page" style="display: flex; justify-content: center; margin-bottom: 100px">
            <pagination v-show="pageInfo.pageTotal > 0" :total="pageInfo.pageTotal" :page.sync="pageInfo.pageNum"
                :limit.sync="pageInfo.pageSize" @pagination="getProductData" />
        </div>

        <bottomNav />
    </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import listNav from "../../components/listNav.vue";
import pagination from "../../components/pagination.vue";
import isBuilding from "../../components/isBuilding.vue";
import dataNone from "@/components/dataNone.vue";

export default {
    components: {
        dataNone,
        topWell,
        bottomNav,
        listNav,
        pagination,
        isBuilding
    },
    data() {
        return {
            StrategyData: [],
            InvestorData: [],
            classData: [],
            classType: 0,
            classValue: 1,
            pageInfo: {
                pageSize: 9,
                pageNum: 1,
                pageTotal: 2,
            },
            productList: [],
            pageLoading: false,
        };
    },
    created() {
        this.getClassData()
        this.getStrategyData()
        this.getProductData()
        this.getInvestorData()
        /*if(this.classType=='投资案例'){
        }else{
        }*/
    },
    methods: {

        // 获取投资案例列表
        getProductData() {
            this.productList = []
            this.pageLoading = false;
            this.$api.getTZList({
                classify: this.classValue,
                isIndexShow: 0,
                ...this.pageInfo
            }).then(res => {
                this.productList = res.rows
                this.pageInfo.pageTotal = res.total;
                this.pageLoading = true;
            })
        },
        // 获取投资项目分类
        getClassData() {
            this.$api.getTZClassify().then(res => {
                this.classData = res.data
                this.classType = this.classData.length > 0 ? this.classData[0].dictLabel : '重点投向'
            })
        },
        // 获取聚焦两大重点投资领域
        getInvestorData() {
            this.$api.getInvestor().then(res => {
                this.InvestorData = res.data
            })
        },
        // 获取三大战略性新兴产业集群
        getStrategyData() {
            this.$api.getStrategy().then(res => {
                this.StrategyData = res.data
            })
        },
        checkPageInd(v) {
            console.log(v)
            this.classType = v.dictLabel
            this.classValue = v.dictValue;
            this.getProductData()
        }
    },
};
</script>
<style scoped lang="less">
.mainBox {
    font-family: "思源黑体";
    box-sizing: border-box;

    #main {
        margin: 0 auto;
        min-width: 93.75rem
            /* 1500/16 */
        ;
        width: 93.75rem
            /* 1500/16 */
        ;
        padding: 100px 6.5rem;
        padding-right: 5rem;
        display: flex;
        justify-content: space-between;
        padding-bottom: 0;

        .tagright {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item {
                width: 48%;
                margin-bottom: 100px;

                img {
                    width: 100%;
                }

                .title {
                    font-size: 18px;
                    line-height: 36px;
                    color: #666;
                    //margin-top: 30px;
                }
            }
        }
    }
}

.tagleft {
    img {
        display: block;
    }

    .icon-line {
        width: 89px;
        margin-top: 36px;
        margin-bottom: 30px;
    }

    .leftTitle {
        font-size: 35px;
        font-weight: bold;
    }
}

#culture {
    padding: 150px 0;
    background: url("../../static/aboutUsBanner2.png") no-repeat;
    background-size: cover;
    min-width: 93.75rem
        /* 1500/16 */
    ;

    .box {
        padding: 0 6.5rem
            /* 104/16 */
        ;
        min-width: 93.75rem
            /* 1500/16 */
        ;
        display: flex;
        justify-content: space-between;
        width: 93.75rem
            /* 1500/16 */
        ;
        margin: 0 auto;
    }

    .info {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .item {
            width: 300px;

            .title {
                color: #1e439b;
                font-size: 20px;
                font-weight: bold;
                margin: 20px 0;
            }

            .tit {
                font-size: 16px;
                line-height: 30px;
                color: #666;
            }
        }
    }
}

#bottom {
    margin: 0 auto;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem
        /* 1500/16 */
    ;
    padding: 100px 6.5rem;
    padding-right: 5rem;
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;

    .tagright {
        .item {
            margin-bottom: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                width: 320px;
            }

            .text {
                margin-left: 20px;
            }

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #333;
                margin-bottom: 30px;
            }

            .tit {
                font-size: 18px;
                line-height: 36px;
                color: #666;
            }
        }
    }
}

.productList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem
        /* 1500/16 */
    ;
    padding: 0 6.5rem;
    padding-top: 50px;

    .item {
        width: 400px;
        margin-right: 30px;
        margin-bottom: 100px;

        &:nth-child(3n) {
            margin-right: 0;
        }

        img {
            width: 400px;
            height: 250px;
        }

        .title {
            margin: 20px 0;
            font-size: 20px;
            font-weight: bold;
            color: #1E439B;
        }

        .tit {
            font-size: 18px;
            line-height: 36px;
            color: #666;
        }
    }
}</style>
